export function NotFound() {
  return <h1 className="text-l text-center p-2">Route is not available.</h1>;
}
